<template>
  <div>
    <v-snackbar v-model="snackbar" :timeout="4000" top color="success">
        <span>Configured Successfully</span> 
        <v-btn text color="white" @click="snackbar = false">Close</v-btn>
      </v-snackbar>

      <v-snackbar v-model="snackbar1" :timeout="4000" top color="red">
          <span>Not Configured</span> 
          <v-btn text color="white" @click="snackbar = false">Close</v-btn>
      </v-snackbar>
    <div :class="{'mx-9':$vuetify.breakpoint.lgAndUp, 'mx-0': $vuetify.breakpoint.mdAndDown}">
    <!-- <div> -->
    <v-container>
      <v-row class="py-4">
        <v-col cols="12" md="4" sm="4" >
            <v-card height="150" hover @click="routeCommunity()">
              <v-card-title class="headline" style="color:#62AE32"><span class="mt-7">Communities</span></v-card-title>
              <v-card-title class="mt-n5 font-weight-black">{{this.$store.state.community.communityCount}}</v-card-title>
            </v-card>
        </v-col>
        <v-col cols="12" md="4" sm="4" >
            <v-card height="150" hover @click="routeMember()">
              <v-card-title class="headline" style="color:#62AE32"><span class="mt-7">Members</span></v-card-title>
              <v-card-title class="mt-n5 font-weight-black">{{this.$store.state.community.memberCount}}</v-card-title>
            
            </v-card>
        </v-col>
          <v-col cols="12" md="4" sm="4" >
            <v-card height="150" hover @click="routePolicy()">
              <v-card-title class="headline" style="color:#62AE32"><span class="mt-7">Expired Policy</span></v-card-title>
              <v-card-title class="mt-n5 font-weight-black">{{this.$store.state.community.expiredPremium}}</v-card-title>
              
            </v-card>
        </v-col>
      </v-row>

      <v-dialog persistent v-model="dialog" max-width="300px">
        <v-card>
            <v-card-title>
            <span class=" black--text">Days</span>
            </v-card-title>

            <v-card-text>
            <v-container>
                <v-text-field
                    color="#62AE32"
                    label=""
                    type="number"
                    outlined
                    flat
                    dense
                    v-if="notifications.length>0"
                    v-model="notifications[0].days_before_notify"
                    style="font-size:14px"
                    class="black--text"
                ></v-text-field>
                                    
            </v-container>
            </v-card-text>

            <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn color="#62AE32" text @click="dialog=false">CANCEL</v-btn>
            <v-btn color="#62AE32" :loading="loading" text @click="update()">Update</v-btn>
            
            </v-card-actions>
        </v-card>
      </v-dialog>
      <template>
          <v-data-table
            :headers="headers"
            :items="Transactions"
            :class="elevation-1"
            class="mt-5 px-5"
            :items-per-page="5"
            hide-default-footer = true
            no-data-text="No Recent Transactions For Display"
          >
              <template  v-slot:top>
                  <v-toolbar flat color="white">
                      <v-toolbar-title class="font-weight-black">Recent Transactions</v-toolbar-title>
                      
                  </v-toolbar>
                  <v-divider class=""></v-divider>
              </template>
              <template v-slot:item.payment_amount="{ item }">
                  <span>&#8358;{{item.payment_amount}}</span>
              </template>
              <template v-slot:item.action="{ item }">
                  <v-icon
                      style="color:#B45C5C; cursor: pointer;"
                      @click="getTransactionById(item.transaction_id)"
                  >
                      mdi-chevron-right
                  </v-icon>
              </template>

          </v-data-table>
      </template>
      <!-- Members Start Here -->
      <template>
          <v-data-table
            :headers="headerMembers"
            :items="Members"
            :items-per-page="5"
            :single-select="singleSelect"
            hide-default-footer = true
            item-key="name"
            class="mt-8 px-5"
            no-data-text="No Members To Display"
          >
              <template  v-slot:top>
                  <v-toolbar flat color="white">
                      <v-toolbar-title class="font-weight-black">Recently Added Members</v-toolbar-title>
                      
                  </v-toolbar>
                  <v-divider class=""></v-divider>
              </template>
              <template v-slot:item.action="{ item }">
                <div @click="getName(item.Id)" style="color:#B45C5C; cursor: pointer;">
                  View more
                </div>
              </template>

          </v-data-table>
      </template>

      <!-- Member End here -->
      <template>
          <v-data-table
            :headers="notifyheaders"
            :items="notifications"
            :class="elevation-1"
            class="mt-8 px-5 mb-12"
            :items-per-page="5"
            hide-default-footer = true
            no-data-text="No Notification Configuration For Display"

          >
              <template  v-slot:top>
                  <v-toolbar flat color="white">
                    <v-toolbar-title class="font-weight-black">Claim Notification Configuration</v-toolbar-title>
                  </v-toolbar>
                  <v-divider class=""></v-divider>
              </template>
              <template v-slot:item.action="{  }">
                  <v-icon
                      style="color:#B45C5C; cursor: pointer;"
                      @click="dialog=true"
                  >
                      mdi-pencil
                  </v-icon>
              </template>

          </v-data-table>
      </template>
      <!-- Daily Activities Log -->
      <template>
        <v-data-table
          :headers="activitiesHeader"
          :items="activities"
          :items-per-page="5"
          item-key="name"
          class="mt-4 px-5 mb-12"
          no-data-text="No Activities To Display For Today"
          :loading='loadActivities'
        >
          <template  v-slot:top>
              <v-toolbar flat color="white">
                <v-toolbar-title class="font-weight-black">Daily Activities Log</v-toolbar-title>
                <v-spacer></v-spacer>
                <v-icon color='green'  @click="refresh()">mdi-refresh</v-icon>
                <v-spacer></v-spacer>
                  <v-select outlined label="sort by.." color="#08911B" :items="activityTypes" v-model="activityType" class="mt-8" dense style="width:40%" @change="onChange($event)">

                  </v-select>
              </v-toolbar>
          </template>
          <template v-slot:item.icon="{ item }">
            <v-icon style="color:#B45C5C" v-if="item.activity_type==='Claims'">mdi-human-greeting</v-icon>
            <v-icon style="color:#B45C5C" v-if="item.activity_type==='Transaction'">mdi-finance</v-icon>
            <v-icon style="color:#B45C5C" v-if="item.activity_type==='Subscription'">mdi-account-key</v-icon>
            <v-icon style="color:#B45C5C" v-if="item.activity_type==='Member'">mdi-account-group</v-icon>
            <v-icon style="color:#B45C5C" v-if="item.activity_type==='Consultant'">mdi-account-group</v-icon>
            <v-icon style="color:#B45C5C" v-if="item.activity_type==='Community'">mdi-google-circles-communities</v-icon>
            <v-icon style="color:#B45C5C" v-if="item.activity_type==='Loss Assessor'">mdi-account-supervisor-circle</v-icon>
            <v-icon style="color:#B45C5C" v-if="item.activity_type==='Marketing Consultant'">mdi-account-tie-voice</v-icon>
          </template>
        </v-data-table>
      </template>

      <!-- CHARTS -->
      <v-card flat class="py-1 mb-7">
        <v-toolbar flat color="white" class="mt-3">
          <v-toolbar-title class="font-weight-black ml-7">Transactions For Year {{year}} in Naira(&#8358;)</v-toolbar-title>
          <v-spacer></v-spacer>
          <v-select outlined color="#08911B" :items="years" class="mt-8" dense @change="save($event)" label="filter with year.."></v-select>
          <!-- <v-menu
            ref="from"
            v-model="from"
            :close-on-content-click="false"
            :nudge-right="40"
            transition="scale-transition"
            offset-x
            min-width="290px"
            >
            <template v-slot:activator="{ on }">
              <v-text-field
                v-model="date"
                label="From"
                prepend-icon="event"
                readonly
                v-on="on"
              ></v-text-field>
            </template>
            <v-date-picker  ref="picker" v-model="date" @input="save" reactive no-title></v-date-picker>
          </v-menu> -->
        </v-toolbar>
        
        <div  class="text-center">
          <v-progress-circular v-if="loaded===false" indeterminate :size="50" :width="5" color="#08911B" class="ma-8" ></v-progress-circular>
          <LineChart v-if="loaded" :data="transactionsLine" :styles="styles" class="ma-3"/>
        </div>
        <!-- <BarChart v-if="loaded" :data="transactionsLine" :styles="styles" class="ma-3"/> -->
        <!-- <div id="app" class="pa-5">
          <canvas id="payment-chart"></canvas>
        </div> -->
      </v-card>
          
        
        
    </v-container>
    </div>
  </div>
</template>

<script>
import Chart from 'chart.js';
import LineChart from "../components/LineChart";
// import BarChart from '../components/Barchart2'
export default {
  name: 'dashboard',
  components: {
    LineChart,
    // BarChart,
  },
  data: () => ({
    snackbar:false,
    snackbar1:false,
    dialog:false,
    loading:false,
    monthlyPremiumPayment:[7,8,9],
    monthlyClaimPayment:[9,0,8],
    year:new Date().getFullYear(),
    from:'',
    date:'',
    activityTypes:['All','Claims','Transaction','Subscription','Member', 'Consultant', 'Community','Loss Assessor','Marketing Consultant'],
    activityType:'',
    date:'',
    notifyheaders:[
       {
          text: 'Days before notifying users',
          align: 'left',
          sortable: false,
          value: 'days_before_notify',
          class:'font-weight-black'
        },
        {text: "Configured By", value:'configured_by'},
        {text:'Date Configured', value:'date_created'},
        { text: '', value: 'action', sortable: false },
    ],
    headers: [
        {
          text: 'Community',
          align: 'left',
          sortable: false,
          value: 'community_name',
          class:'font-weight-black'
        },
        {text: "Depositor's Name", value:'depositors_name'},
        // {text:'Policy Number', value:'policy_number'},
        {text:'Amount', value:'payment_amount'},
        {text:'Date', value:'date_created'},
        { text: '', value: 'action', sortable: false },
    ],
    activitiesHeader: [
      {
        text: '',
        align: 'left',
        sortable: false,
        value: 'icon',
      },
      {text: "Type", value:'activity_type'},
      {text:'Activity', value:'activity_message'},
      {text:'Date', value:'date_created'},
    ],
    headerMembers: [
        {
        text: 'Name',
        align: 'left',
        sortable: false,
        value: 'name',
        class:'font-weight-black'
        },
        {text: 'Username', value:'username'},
        {text:'Email', value:'email', sortable: false},
        {text:'PhoneNumber', value:'phonenumber', sortable: false},
        { text: '', value: 'action', sortable: false },
    ],
    transactionsLine:null,
    years:['2019', '2020', '2021', '2022', '2023', '2024', '2025', '2026', '2027', '2028', '2029', '2030', '2031', '2032','2033', '2034', '2035', '2036', '2037', '2038', '2039', '2040'],
    styles: {
      position: "relative",
      height: "400px"
    },
    loaded:false,
    loadActivities:false
  }),
  
  computed:{
    Transactions(){
        let trans= this.$store.state.transactions.recentTransactions
        for(let j=0; j<trans.length; j++){
          trans[j].payment_amount = parseFloat(trans[j].payment_amount).toFixed(2)
          trans[j].payment_amount = trans[j].payment_amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
          trans[j].date_created= trans[j].date_created.slice(0, 19).replace('T', ' ');
        }
        return trans
    },
    Members(){
      return this.$store.state.community.members
    },
    notifications(){
      let notify = this.$store.state.notifications.notificationConfig
      for(let k=0; k<notify.length; k++){
        notify[k].date_created = notify[k].date_created.slice(0, 19).replace('T', ' ')
      }
      return notify
    },
    getCaimAmountWithMonths(){
      return  this.$store.state.reports.ClaimMonthsAmount.claimMonth
      
    },
    getPremiumAmountWithMonths(){
      return this.$store.state.reports.PremiumMonthsAmount.premiumMonth
      
    },
    activities(){
      let activities= this.$store.state.activities.activities
      for(let j=0; j<activities.length; j++){
        activities[j].date_created= activities[j].date_created.slice(0, 19).replace('T', ' ');
      }
      return activities
    }
  },
  
  methods:{
    save(event){
      // alert(event)
      this.loaded=false
      // var d = new Date(date);
      // var n = d.getFullYear();
      // this.date=n
      // this.$refs.from.save(n);
      // this.from = false;
      this.year= event
      // claims amount paid for the year with months
      this.$store.dispatch("getClaimsAmountWithMonthsFilter", {from:this.year+'-01-01-', to:this.year+'-12-31'})
      .then(()=>{
          // premium amount paid for the year with months
          this.$store.dispatch("getPremiumAmountWithMonthsFilter", {from:this.year+'-01-01-', to:this.year+'-12-31'})
          .then(()=>{
            const results=  this.$store.state.reports.ClaimMonthsAmount.claimMonth
            // let monthlyClaimAmount = results.map(a=>a.total_num)
            // this.monthlyClaimPayment=monthlyClaimAmount
            const result2= this.$store.state.reports.PremiumMonthsAmount.premiumMonth
            let arr=[]
            arr[0]=results
            arr[1]=result2
            this.transactionsLine=arr
            this.loaded=true
                // let monthlyPremiumAmount = result2.map(a=>a.total_num)
                // this.monthlyPremiumPayment = monthlyPremiumAmount
              //   const planetChartData = {
              //   type: 'line',
              //   data: {
              //     labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July','August', 'September', 'October', 'November', 'December'],
              //     datasets: [
              //       { // one line graph
              //         label: 'Monthly Premium Transaction',
              //         data: this.monthlyPremiumPayment,
              //         // data: [0,4,5,5],
              //         backgroundColor: '#0074D9',
              //         borderColor: '#0074D9',
              //         borderWidth: 3
              //       },
              //       { // another line graph
              //         label: 'Monthly Claims Transaction',
              //         data: this.monthlyClaimPayment,
              //         // data: [0,9,7],
              //         backgroundColor: '#FF4136',
              //         borderColor: [
              //           '#47b784',
              //           // '#FF4136',
              //         ],
              //         borderWidth: 3
              //       }
              //     ]
              //   },
              //   options: {
              //     responsive: true,
              //     lineTension: 1,
              //     scales: {
              //       yAxes: [{
              //         ticks: {
              //           beginAtZero: true,
              //           padding: 25,
              //         }
              //       }]
              //     }
              //   }
              // }
              // this.createChart('payment-chart', planetChartData);
          })
          .catch(()=>{
        });
      })
      .catch(()=>{
        
      })
      
    
    },
    update(){
      this.loading=true
      this.$store.dispatch("updateConfig", {
        id:this.$store.state.notifications.notificationConfig[0].id,
        numberOfDays:this.$store.state.notifications.notificationConfig[0].days_before_notify,
        username:this.$store.state.community.logindetails.consultant_id
      })
      .then(()=>{
        this.loading=false
        this.snackbar=true
        this.dialog=false
      })
      .catch(()=>{
        this.loading=false
        this.snackbar1=true
        this.dialog= false
      })
    },
    getTransactionById(id){
      this.$store.dispatch("TransactionsById", id)
      .then((success)=>{
     this.$router.push(`/transactions/viewTransaction/${success.policy_holder}`)
      })
      .catch(()=>{
      })
    },
    routeMember(){
      this.$router.push('/member')
    },
    routeCommunity(){
      this.$router.push('/community')
    },
    routePolicy(){
      this.$router.push('/subscriptions')
    },
    getName(id){
      this.$store.dispatch("MembersById",id)
      .then((success)=>{
      this.$router.push(`/community/members/${success.member[0].username}`)
      })
      .catch(()=>{
      }) 
    },
    onChange(event) {
      this.loadActivities = true
      if (event === 'All'){
        this.$store.dispatch("GetActivities")
        .then(()=>{
          this.loadActivities=false
        })
        .catch(()=>{
          this.loadActivities = false
        });
      }else{
        this.$store.dispatch("GetActivitiesWithFilter", {type:event})
        .then(()=>{
          this.loadActivities = false
        })
        .catch(()=>{
          this.loadActivities = false
        }); 
      }
    },
    refresh(){
      this.loadActivities = true
      this.$store.dispatch("GetActivities")
      .then(()=>{
        this.loadActivities=false
      })
      .catch(()=>{
        this.loadActivities = false
      });
    },
    // ==============================CHARTS=================================
    createChart(chartId, chartData) {
      const ctx = document.getElementById(chartId);
      const myChart = new Chart(ctx, {
        type: chartData.type,
        data: chartData.data,
        options: chartData.options,
      });
    }
  },
  created(){
    // notification config
     this.$store.dispatch("getNotificationConfig")
      .then(()=>{
      })
      .catch(()=>{
      });
    // recent transactions
     this.$store.dispatch("getRecentTransactions")
      .then(()=>{
      })
      .catch(()=>{
      });
      // community count
      this.$store.dispatch("getCommunityCount")
      .then(()=>{
      })
      .catch(()=>{
      });
      // memebers count
       this.$store.dispatch("getMembersCount")
      .then(()=>{
      })
      .catch(()=>{
      });

    //expired premiums
    this.$store.dispatch("getExpiredPremiums")
    .then(()=>{
    })
    .catch((error)=>{
    });
    // get Members
    this.$store.dispatch("getMembers")
    .then(()=>{
    })
    .catch(()=>{
    });
    // get Activities
    this.$store.dispatch("GetActivities")
    .then(()=>{
    })
    .catch(()=>{
    });
    // claims amount paid for the year with months
    this.$store.dispatch("getClaimsAmountWithMonths")
    .then(()=>{
    })
    .catch(()=>{
    });
    // premium amount paid for the year with months
    this.$store.dispatch("getPremiumAmountWithMonths")
    .then(()=>{
    })
    .catch(()=>{
    });
    const results=  this.$store.state.reports.ClaimMonthsAmount.claimMonth
    const result2= this.$store.state.reports.PremiumMonthsAmount.premiumMonth
    let arr=[]
    arr[0]=results
    arr[1]=result2
    this.transactionsLine=arr
    this.loaded=true
  },

  watch: {
    from (val) {
    val && this.$nextTick(() => (this.$refs.picker.activePicker = 'YEAR'))
  },
  }
 
};
</script>
<style  scoped>
  #item{
    background-color:#F0FFEA !important;
    min-height:100vh;
  }
</style>